import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { welfareReceiveList, gmWelfareLevelLists } from "@/api/gmtool/packageCode";
import givingOutBenefits from "./components/givingOutBenefits.vue";
import { gmTool } from "@/mixins/index";
export default {
  name: "welfareOperation",
  components: {
    givingOutBenefits: givingOutBenefits
  },
  mixins: [gmTool],
  data: function data() {
    return {
      date: null,
      paramsData: {
        page: 1,
        device_id: '',
        user_id: '',
        name: '',
        startTime: '',
        endTime: '',
        refresh_interval: ''
      },
      gmWelfareLevelListsList: []
    };
  },
  activated: function activated() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.getList();

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    refresh: function refresh() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return gmWelfareLevelLists({
                  is_prod: _this2.paramsData.is_prod
                });

              case 2:
                _this2.gmWelfareLevelListsList = _context3.sent.data;

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    getList: function getList() {
      var _this3 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      this.reqLoading = true;
      this.paramsData.page = page;
      var date = this.date;
      this.paramsData.startTime = date ? date[0] / 1000 : '';
      this.paramsData.endTime = date ? date[1] / 1000 : '';
      welfareReceiveList(this.paramsData).then(function (res) {
        if (res.status == 200) {
          if (!res.data.data.length && page > 1) {
            _this3.getList(page - 1);
          } else {
            res.data.data.map(function (i) {
              i.name = i.name ? i.name : _this3.$t('deleted');
              i.is_del = i.is_del ? _this3.$t('yes') : _this3.$t('no');
            });
            _this3.tableData = res.data.data;
            _this3.total = res.data.total;
          }
        }
      }).finally(function () {
        _this3.reqLoading = false;
      });
    },
    exportdata: function exportdata() {
      var Dynamic = [{
        label: this.$t('accountOwner'),
        prop: 'input'
      }, {
        label: this.$t('remark'),
        prop: 'textarea'
      }, {
        label: this.$t('operator'),
        prop: 'admin_name'
      }, {
        label: this.$t('roleId'),
        prop: 'user_id'
      }, {
        label: this.$t('ip'),
        prop: 'ip'
      }, {
        label: this.$t('benefitLevel'),
        prop: 'name'
      }, {
        label: this.$t('claimedAmountCents'),
        prop: 'amount'
      }, {
        label: this.$t('isWhitelistUser'),
        prop: 'is_del'
      }, {
        label: this.$t('operationTime'),
        prop: 'created_at'
      }];
      this.$export.excel({
        columns: Dynamic,
        data: this.tableData,
        title: this.$t('benefitClaimOperationRecord')
      });
    }
  }
};